import { $, $$ } from './plugins/selectors';

$('#pdf').addEventListener('change', () => { console.log('change') })